import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import moment from 'moment';

import { TableRow, TableRowColumn } from 'material-ui/Table';

import styles from 'styles';

const now = moment();

function checkRelevantDateRange(currentDate, currentMonth, subscription) {
    return (currentDate >= moment(subscription.from).date()) && (currentDate <= moment(subscription.to).date() || currentMonth < moment(subscription.to).month());
}

function getCurrentSubscription(subscriptions) {
    const currentYear = now.year();
    const currentMonth = now.month();
    const currentDate = now.date()

    const subscriptionsWithinMonth = subscriptions.filter(subscription => {
        const fromYear = moment(subscription.from).year();
        const fromMonth = moment(subscription.from).month();
        const toYear = moment(subscription.to).year();
        const toMonth = moment(subscription.to).month();
        
        return (
            currentYear >= fromYear && 
            currentMonth >= fromMonth &&
            currentYear <= toYear &&
            currentMonth <= toMonth 
        );
    });

    let result = subscriptionsWithinMonth && subscriptionsWithinMonth.length && subscriptionsWithinMonth[0].packageType || 0;
    if (subscriptionsWithinMonth.length > 1) {
        subscriptionsWithinMonth.forEach(subscription => {
            if (currentMonth > moment(subscription.from).month()) {
                if (currentMonth < moment(subscription.to).month()) {
                    result = subscription.packageType;
                } else {
                    // here currentMonth is equal to toMonth
                    if (checkRelevantDateRange(currentDate, currentMonth, subscription)) {
                        result = subscription.packageType;
                    }
                }
            } else if (currentMonth >= moment(subscription.from).month() && currentMonth <= moment(subscription.to).month()) {
                if (checkRelevantDateRange(currentDate, currentMonth, subscription)) {
                    result = subscription.packageType;
                }
            }
        });
    }

    return result;
}

class StatisticsUsersRow extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            item: props.item,
        };

    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        this.setState({
            item: nextProps.item,
        })
    }

    render() {
        const { item } = this.state;
        let phone = '';

        if (item.phones && item.phones.length) {
            if (item.phones[0].code) {
                phone = `+${item.phones[0].code.replace('+', '')} ${item.phones[0].phone}`
            } else {
                phone = item.phones[0].phone;
            }
        }

        return (
            <TableRow>
                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.name }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.surname }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.email }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.companyName }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.organizationType }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.country }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { phone }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { moment(item.createdAt).format('MM-DD-YYYY') }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.emailVerified ? '+' : '-' }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.emailVerifiedAt ? moment(item.emailVerifiedAt).format('MM-DD-YYYY') : '-' }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.password ? '+' : '-' }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.subscriptions.length && getCurrentSubscription(item.subscriptions) }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.subscriptions.length && moment(item.subscriptions[0].from).format('MM-DD-YYYY') }
                </TableRowColumn>

                <TableRowColumn style={styles.tableRowColumnCSS}>
                    { item.subscriptions.length && moment(item.subscriptions[item.subscriptions.length - 1].to).format('MM-DD-YYYY') }
                </TableRowColumn>
            </TableRow>
        );
    }
}

export default connect(
    (state, { item }) => {
        return {
            item,
        };
    },
    dispatch => bindActionCreators({

    },
    dispatch),
)(StatisticsUsersRow);



// WEBPACK FOOTER //
// ./app/components/Statistics/Users/Table/Row.jsx